import type { CalendarBoxes, CalendarDesign } from "#internal"

import { PocketBand } from "../PocketBand"
import { PocketMonths } from "../PocketMonths"

// Half the year under a band of picture with the year on it, three across
const half = (boxes: CalendarBoxes, first: number) => {
  const { areas, below } = PocketBand(boxes, 0.23)
  return [...areas, ...PocketMonths(below, boxes.year, 3, first, first + 5)]
}

/** Madison, a pocket calendar: a band of picture with the year on it at the
 * head of either side, January to June under it on the front, July to
 * December on the back. */
export const Madison: CalendarDesign = {
  cover: boxes => half(boxes, 1),
  page: boxes => half(boxes, 7),
  pages: "year",
}
